var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"form"},[_c('form-header',{attrs:{"title":_vm.title,"cancel-url":_vm.cancelUrl}},[_vm._t("buttons")],2),_vm._t("default"),_c('form-footer',{attrs:{"cancel-url":_vm.cancelUrl}},[_vm._t("buttons")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }